// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * fps-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: local
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LoginDTOAPIModel
 */
export interface LoginDTOAPIModel {
    /**
     * 
     * @type {string}
     * @memberof LoginDTOAPIModel
     */
    token: string;
}

export function LoginDTOAPIModelFromJSON(json: any): LoginDTOAPIModel {
    return LoginDTOAPIModelFromJSONTyped(json, false);
}

export function LoginDTOAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginDTOAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function LoginDTOAPIModelToJSON(value?: LoginDTOAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
    };
}


